export enum UserType {
  Customer = 'CUSTOMER',
  Admin = 'ADMIN',
}
